export default {
  content: ''+
  '<div class="text-box">'+
  // '<h3 class="h3-line">(一)竞赛飞行时间：12～15分钟</h3>'+
  '<h3 class="h3-line">竞赛飞行流程</h3>'+
  '<h3 class="h3-sub-line">1．选手解锁飞行器，竞赛计时开始，选手启动飞行器，进入竞赛环节。</h3>' +
  '<h3 class="h3-sub-line">2．竞赛飞行轨迹</h3>' +
  '<p class="text-line">科目①：起飞，由起降平台起飞至目视高度，穿过圆圈飞向科目②； </p>'+
  '<p class="text-line">科目②：在飞行高度低于标杆高度上限的前提下，逆时针方向(俯视角度)环绕一圈，飞向科目③；</p>'+
  '<p class="text-line">科目③：飞行器从横杆下部穿越，沿顺时针方向(竞赛选手站位视角)环绕横杆一周，经横杆下部飞向科目④；</p>'+
  '<p class="text-line">科目④：首先从上向下穿越高位圆圈④A，然后从下向上穿越低位圆圈④B，之后飞向科目⑤；</p>'+
  '<p class="text-line">科目⑤：按照⑤A-⑤B-⑤C的先后顺序，连续穿越蛇形连环圈，共三个，之后飞向科目⑥；</p>'+
  '<p class="text-line">科目⑥：飞回停机坪上空，并降落至起降平台。飞机降落后，选手操作锁桨，桨叶停止转动，计时停止。</p>'+
  '<p class="text-line">由于是飞行接力赛，按照下图设计的赛道，共计飞行两圈。 </p>'+
  '<p class="text-line">四名选手接力交接期间，需要在指定的选手交接活动区域完成交接，竞赛场地内不得同时出现超过两名参赛选手。</p>'+
  '<h3 class="h3-sub-line">3．竞赛接力轨迹</h3>' +
  '<p class="text-line">1～2号选手先进入“移动区域”，并确保“教练线”正确连接两台遥控器，1号选手完成指定科目①～③飞行环节，然后把遥控器从教练模式切换到学生模式，该模式切换要求在进入科目④前完成。</p>'+
  '<p class="text-line">2号选手在开始科目④环节前接手控制飞行器。1号选手沿指定选手交接活动区域快速撤离赛道，并迅速与3号选手完成替换，注意，需要在1号选手完全撤离赛道场地后，3号选手才能进入场地。 </p>'+
  '<p class="text-line">2号选手在完成指定科目④～⑥环节期间。3号选手需及时上场就位。2号选手在进行科目⑥时，只需将飞行器飞到起降平台上空3号选手即可进行交接，而后继续执行科目①；接管完成后，2号选手可以做离场准备，注意，需要在2号选手完全撤离赛道场地后，4号选手才能进入场地。</p>'+
  '<p class="text-line">4号选手需要在3号选手进行指定科目①～③期间及时上场就位，待3号选手完成科目③后，由3号选手将遥控器从教练模式切换到学生模式，该模式切换要求在进入科目④前完成，之后由4号选手接手飞行器完成指定科目④～⑥环节，直至飞行器降落到起降平台，选手锁桨至完全停桨，则接力赛结束计时。</p>'+
  '<img class="img-line" src="/work/static/img/uva/XTJ/t33.jpg" width="100%" />' +
  '<img class="img-line" src="/work/static/img/uva/XTJ/t34.jpg" width="100%" />' +
  '</div>'
}